import { useLocation, useNavigate, useParams } from "react-router-dom";
import { dropDownWhite } from "../../asset";
import CustomButton from "../../components/CustomButton";
import PageHeader from "../../components/PageHeader";
import ActionDropDown from "./ActionDropDown";
import { useEffect, useState } from "react";
import classesApis from "../../api/classesApis";
import InfoCard from "../../components/InfoCard";
import useDropdown from "../../util/hooks/useDropDown";
import { ClassApiResponse } from "../../types/classesTypes";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import AttendanceReportDropDown from "../../components/AttendanceReportDropdown";
import AttendanceReportByDate from "../../components/modal/AttendanceReportByDate";

export default function ClassHeaderSection({
  totalStudents,
  openAssignTeacherModal,
}: {
  totalStudents?: number;
  openAssignTeacherModal?: () => void;
}) {
  const { state } = useLocation();
  const { classId } = useParams();
  const location = useLocation();
  const { isOpen, toggleDropdown, dropdownRef } = useDropdown();
  const [classInfo, setClassInfo] = useState<ClassApiResponse>(state);
  const navigate = useNavigate();

  const isAttendancePage = location.pathname.includes("attendance-details");

  const [isDateModalOpen, setIsDateModalOpen] = useState(false);

  useEffect(() => {
    if (!state && classId) {
      classesApis.fetchClassById(Number(classId)).then((res) => {
        if (res?.data) {
          setClassInfo(res.data);
        }
      });
    }
  }, [state, classId]);

  const titleText = `${classInfo?.className ?? ""}`;
  const finalTitle = isAttendancePage ? `ATTENDANCE - ${titleText}` : titleText;

  const menuItems = [
    {
      label: "Academic Year Wise",
      onClick: () => navigate(popupNavigation("yearlyReport")),
    },
    {
      label: "Month Wise",
      onClick: () => navigate(popupNavigation("monthlyReport")),
    },
    {
      label: "Date Wise",
      onClick: () => setIsDateModalOpen(true),
    },
  ];

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col sm:flex-row sm:justify-between gap-2 sm:items-center">
        <PageHeader title={finalTitle} showBack onBack={() => navigate("/classes")} />
        <div className="flex gap-4 justify-end items-end sm:justify-center sm:items-center">
          <AttendanceReportDropDown menuItems={menuItems} />
          {!isAttendancePage && (
            <div className="relative" ref={dropdownRef}>
              <CustomButton
                text="Action"
                color="bg-primary-600"
                iconPosition="right"
                icon={dropDownWhite}
                onClick={toggleDropdown}
                iconClassName={`${
                  isOpen ? "rotate-180" : "rotate-0"
                } transition-transform duration-300`}
              />
              <ActionDropDown
                open={isOpen}
                classData={classInfo}
                openAssignTeacherModal={openAssignTeacherModal}
              />
            </div>
          )}
        </div>
      </div>
      <div className="bg-white sm:px-8 px-4 py-4 rounded-lg grid sm:grid-cols-2 gap-4 md:gap-11">
        <InfoCard
          label="Academic Cycle"
          value={classInfo?.academicCycle}
          bgColor="bg-success-50"
          textColor="text-success-700"
        />
        <InfoCard
          label="Total Number of Students"
          value={
            totalStudents !== undefined
              ? totalStudents
              : classInfo?.noOfStudents || "0"
          }
          bgColor="bg-warning-50"
          textColor="text-warning-700"
        />
      </div>

      {isDateModalOpen && (
        <AttendanceReportByDate
          onClose={() => setIsDateModalOpen(false)}
          onSuccess={(date: string, classId: number) => {
            setIsDateModalOpen(false);
            navigate(`/classes/attendance-details/${classId}?date=${date}`);
          }}
        />
      )}
    </div>
  );
}
